export default "__VITE_ASSET__5559ec2a__"